var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"reder-ai-container"},[_c('el-button',{staticClass:"back el-icon-arrow-left",attrs:{"plain":""},on:{"click":_vm.goBack}},[_vm._v("返回")]),_c('div',{staticClass:"reder-container"},[_c('iframe',{staticStyle:{"border":"none"},attrs:{"src":_vm.iframeSrc,"width":"100%","height":"100%"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }